import CultureCodeEnum from '../../../../models/culture-code-enum';
import { ProductLineItemType } from '../../../../models/product-line-item-type';
import client from '../../client';

const favouritesGet = async (basketId: string): Promise<unknown> => {
  const { data } = await client.get<{ lineItems: ProductLineItemType[] }>(
    '/favourites/get',
    {
      params: { basketId, cultureCode: CultureCodeEnum.EnGb },
    }
  );

  return data;
};

export default favouritesGet;
